import { all, takeLatest, put, call, fork } from 'redux-saga/effects'
import { actions, constants } from './actions'
import { apiV2 } from '../../services/api'
import { formUtils } from '../questionnaire/utils'
import getLookups from 'views/Config/lookups'

const { UPDATE_FORM, RETRIEVE_CALL_REPORT } = constants
const { updateForm, retrieveCallReport } = actions
const { checkFields, formatPayload } = formUtils(getLookups())

// Action sagas - async
function * updateFormRequest () {
  yield takeLatest('UPDATE_FORM/REQUEST', function * ({ payload }) {
    try {
      const isUpdate = payload.id > 0
      const successMessage = 'Call Report successfully updated.'
      const callReportId = payload.id

      if (payload.originCallReportId === 0) { delete payload.originCallReportId }
      if (!payload.age) { delete payload.age }
      if (!payload.yearsOfMilitaryService) { delete payload.yearsOfMilitaryService }
      if (!payload.yearsOfPoliceService) { delete payload.yearsOfPoliceService }

      // check for required fields
      const callEntryType = payload.callEntryType.value
      const skipValidation = ['wrongNumber', 'nonLawEnforcement', 'noCaller'].includes(callEntryType)
      if (!skipValidation) {
        const { validationErrors } = checkFields(payload)
        if (validationErrors) {
          yield put(updateForm.failure({ source: UPDATE_FORM, message: validationErrors, isUpdate }))
          return
        }
      }

      // Format payload for V2 API - no need for snake_case conversion
      const formattedPayload = formatPayload(payload)

      // Remove fields that V2 extracts from JWT or doesn't need
      delete formattedPayload.id
      delete formattedPayload.callTakerId

      yield call(apiV2.callReports.update, callReportId, formattedPayload)
      yield put(updateForm.success({ source: UPDATE_FORM, message: successMessage, isUpdate }))

    } catch (err) {
      yield put(updateForm.failure({ source: UPDATE_FORM, message: 'Unable to update call report, please try again.' }))
    }
  })
}

function * retrieveCallReportRequest () {
  yield takeLatest('RETRIEVE_CALL_REPORT/REQUEST', function * ({ payload }) {
    try {
      const callReport = yield call(apiV2.callReports.getById, payload.id)
      yield put(retrieveCallReport.success({ source: RETRIEVE_CALL_REPORT, page: callReport }))
    } catch (err) {
      yield put(retrieveCallReport.failure({ source:  RETRIEVE_CALL_REPORT, message: 'Unable to retrieve call report, please try again.' }))
    }
  })
}

// Watcher sagas
export default function * rootSaga () {
  yield all([
    fork(updateFormRequest),
    fork(retrieveCallReportRequest)
  ])
}
